import { Cell, Grid } from 'bold-ui'
import { RadioGroupField, usePecField } from 'components/form'
import { RastreioCancerPerguntaOpcaoEnum } from 'graphql/types.generated'

import { MamografiaPerguntaField } from '../model-mamografia'
import { MamografiaIndicacaoClinicaDiagnosticaFormSection } from './MamografiaIndicacaoClinicaDiagnostica'
import { MamografiaRastreamentoRadioGroupField } from './MamografiaRastreamentoRadioGroupField'
import { tipoMamografiaOptions } from './model-indicacaoClinica'

export function MamografiaIndicacaoClinicaModalStep() {
  const {
    input: { value: tipoMamografia },
  } = usePecField<RastreioCancerPerguntaOpcaoEnum>({
    name: MamografiaPerguntaField.tipoMamografia,
    subscription: { value: true },
  })

  const isRastreamento = tipoMamografia === RastreioCancerPerguntaOpcaoEnum.RASTREAMENTO
  const isDiagnostico = tipoMamografia === RastreioCancerPerguntaOpcaoEnum.DIAGNOSTICO

  return (
    <Grid>
      <Cell size={12} data-testid='tipoMamografia'>
        <RadioGroupField
          name={MamografiaPerguntaField.tipoMamografia}
          label='Tipo de mamografia'
          options={tipoMamografiaOptions}
          required
        />
      </Cell>
      {isRastreamento && (
        <Cell size={12} data-testid='mamografiaRastreamento'>
          <MamografiaRastreamentoRadioGroupField />
        </Cell>
      )}
      {isDiagnostico && <MamografiaIndicacaoClinicaDiagnosticaFormSection />}
    </Grid>
  )
}
